import React, { useEffect, useState } from 'react'
import { IProps } from './index'

export const MutinyVariationComponent: React.FC<IProps> = ({ variations, experimentId }) => {
  const [experience, setExperience] = useState({ isPersonalized: false, variation: '' })

  useEffect(() => {
    if (window.mutiny?.client?.experiences && window.mutiny?.client?.experiences.length > 0) {
      const data = window.mutiny?.client?.experiences.find(
        ({ experience }) => experience.id === experimentId,
      )
      const { experience, isPersonalized } = data || {}
      if (!experience) {
        return
      }

      if (isPersonalized) {
        setExperience({ isPersonalized, variation: experience['variation_name'], ...experience })
      }
    }
  }, [])

  return (
    <>
      <div className="mutiny-variation-container" data-testid="mutiny-variation-container">
        {variations?.map((item) => {
          return !experience.isPersonalized
            ? 'control' === item.name && item.component
            : experience.variation === item.name && item.component
        })}
      </div>
    </>
  )
}
